export default __webpack_public_path__ + "static/media/refresh.824c0db2.png";